<template>
    <div ref="wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        delay: {
            type: Number,
            default: 0.25
        },
        once: {
            type: Boolean,
            default: false
        },
        toggleActions: {
            type: String,
            default: 'play none play none'
        }
    },

    mounted() {
        gsap.from(this.$refs.wrapper, {
            opacity: 0,
            duration: 0.3,
            delay: this.delay,
            scrollTrigger: {
                trigger: this.$refs.wrapper,
                once: this.once,
                toggleActions: this.toggleActions
            }
        });
    }
};
</script>
